import backend from '@common/backend';

const BASE = '/serviceTemplates';

interface IServiceTemplateFromBE {
	id: number;
	name: string;
	service_id: number;
	service_template_characteristics: any[]; // @TODO: TS
}

export const getServiceTemplates = async () =>
	backend.get(`${BASE}/`).then((result: IServiceTemplateFromBE[]) =>
		result.map((serviceTemplate) => ({
			...serviceTemplate,
			service: serviceTemplate.service_id,
		})),
	);
